export const Logo = ({ size = 32 }) => (
  <img
    src="/logo-mark.png"
    alt="ACPZ Consultancy logo"
    className="rounded-md object-cover"
    style={{ width: size, height: size }}
  />
);
